import { useMemo } from 'react';
import type { MarketReview, MarketReviewFilter } from '../types/market-review';

export function useMarketReviewFilters(
  reviews: MarketReview[],
  searchQuery: string,
  filters: MarketReviewFilter
) {
  return useMemo(() => {
    // Start with all reviews
    let filteredReviews = [...reviews];

    // Filter by search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filteredReviews = filteredReviews.filter(review => 
        review.review_lot.toLowerCase().includes(query) ||
        review.review_type.toLowerCase().includes(query) ||
        review.review_comment.toLowerCase().includes(query)
      );
    }

    // Apply additional filters
    if (filters.lot) {
      filteredReviews = filteredReviews.filter(review => 
        review.review_lot === filters.lot
      );
    }

    if (filters.reviewType) {
      filteredReviews = filteredReviews.filter(review => 
        review.review_type === filters.reviewType
      );
    }

    if (filters.reviewDateAfter) {
      const reviewDateAfter = filters.reviewDateAfter;
      filteredReviews = filteredReviews.filter(review => 
        review.review_date >= reviewDateAfter
      );
    }

    if (filters.reviewDateBefore) {
      const reviewDateBefore = filters.reviewDateBefore;
      filteredReviews = filteredReviews.filter(review => 
        review.review_date <= reviewDateBefore
      );
    }

    if (filters.nextReviewBefore) {
      const nextReviewBefore = filters.nextReviewBefore;
      filteredReviews = filteredReviews.filter(review => 
        review.review_next <= nextReviewBefore
      );
    }

    return filteredReviews;
  }, [reviews, searchQuery, filters]);
}
